//import React from 'react';
import { styled } from 'styled-components';
import { WrapperRound } from '~/components/ui/wrapper-round';
//import { classic } from '~/themes/classic';
import bg from '@assets/images/background/friends-bg.png';
import text from '@assets/images/background/friends-v1.svg';
import { useNavigate } from 'react-router-dom';

type IProps = {
  onClick?: () => void;
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function FriendsItem({ onClick }: TProps) {
  const navigate = useNavigate();

  function handleFriendsClick() {
    if (onClick) {
      onClick();
    } else {
      navigate('home/amis');
    }
  }
  return (
    <WrapperRound onClick={handleFriendsClick}>
      <SImgBgWR src={bg} alt="" />
      <SImgText>
        <img src={text} alt="" />
      </SImgText>
    </WrapperRound>
  );
}

const SImgBgWR = styled.img`
  position: absolute;
  right: -2px;
  top: -5px;
  object-fit: contain;
  height: 100%;
  width: 100%;
`;

const SImgText = styled.div`
  position: absolute;
  left: 0;
  bottom: 2px;
  height: 50%;
  width: 70%;
  img {
    right: -1px;
    bottom: 0;
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`;
